import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import {
  CatalogAdminClientProvider,
  CatalogAdminEditionClientProvider,
} from '@/api/catalog-client-context';
import { HttpCatalogAdminEditionClient } from '@/api/catalog-edition-client.http';
import { CatalogVersionsScreen } from '@/routes/admin/catalog/catalog-versions-screen';

// Le browser A-08 lit via CatalogAdminClient (lecture) ET, pour la promotion DRAFT→PUBLISHED
// (BL-FRONT-BACK §2.4), écrit via CatalogAdminEditionClient. La route injecte l'adaptateur HTTP
// réel d'écriture (le défaut du contexte d'édition est un STUB) — parité A-09/A-10/A-25.
const catalogEditionClient = new HttpCatalogAdminEditionClient();

// =============================================================================
// catalog-versions-route.tsx — Adaptateur routeur du browser A-08 (S8-D2).
// =============================================================================
// Route `/admin/catalog/versions` (monde ADMIN, P-05). Le BC catalog AUTO-PORTE son
// DI seam : la route enveloppe l'écran avec le CatalogAdminClientProvider local
// (défaut = stub) plutôt que de brancher le client dans le providers.tsx global
// (surface partagée gelée en parallélisme S8).
//
// Lecture seule : aucune action d'écriture. L'autorité (RBAC admin, transitions d'état)
// reste l'API.

export function CatalogVersionsRoute(): React.JSX.Element {
  const navigate = useNavigate();

  // A-08 → A-09 (édition profil d'une version). campaignVersion = ressource d'URL.
  const onEditVersion = React.useCallback(
    (catalogVersionId: string): void => {
      void navigate({
        to: '/admin/catalog/versions/$catalogVersionId/edit',
        params: { catalogVersionId },
      });
    },
    [navigate],
  );

  // A-08 → A-10 (upload Excel + dry-run).
  const onImportExcel = React.useCallback((): void => {
    void navigate({ to: '/admin/catalog/uploads' });
  }, [navigate]);

  return (
    <CatalogAdminClientProvider>
      <CatalogAdminEditionClientProvider client={catalogEditionClient}>
        <CatalogVersionsScreen
          onEditVersion={onEditVersion}
          onImportExcel={onImportExcel}
        />
      </CatalogAdminEditionClientProvider>
    </CatalogAdminClientProvider>
  );
}
